/* The redesign's content pages (2026-10-08): "On this page", the policies preview, and the privacy notice's dates.
   Loaded by snippets/rd-page.liquid, rd-policy.liquid and templates/page.free.liquid. Everything here only adds: with the
   script off, the page is the admin's text in the reading column, whole. */
(function () {
  'use strict';

  // ---- the policies preview: the address after # picks one; with none, the list ----
  var host = document.querySelector('[data-rd-policies]');
  if (host) {
    var show = function () {
      var want = decodeURIComponent(location.hash.slice(1));
      var all = host.querySelectorAll('[data-policy]'), hit = null;
      for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-policy') === want && want) hit = all[i];
      if (!hit) hit = host.querySelector('[data-policy=""]');
      for (var j = 0; j < all.length; j++) all[j].hidden = all[j] !== hit;
      document.title = hit.getAttribute('data-title') + ' · Picturepops';
      scrollTo(0, 0);
    };
    addEventListener('hashchange', show);
    show();
  }

  // ---- the privacy notice's dates go under the title, in the band (Claude Design: "plain, under the title") ----
  var updated = document.querySelector('.pp-legal__updated'), meta = document.querySelector('[data-rd-meta]');
  if (updated && meta) { meta.innerHTML = updated.innerHTML; meta.hidden = false; updated.remove(); }

  // ---- "On this page": built from the text's own headings, on pages with three or more ----
  var slug = function (t) { return t.toLowerCase().replace(/^\d+\.\s*/, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48) || 'section'; };
  var docs = document.querySelectorAll('[data-rd-doc]');
  for (var d = 0; d < docs.length; d++) build(docs[d]);

  function build(doc) {
    var article = doc.querySelector('article'), aside = doc.querySelector('.rd-toc'), details = doc.querySelector('.rd-contents');
    if (!article || !aside || !details) return;
    var heads = [].slice.call(article.querySelectorAll(':scope > h2, :scope > .pp-legal > h2'));
    if (heads.length < 3) return;
    var used = {};
    var items = heads.map(function (h) {
      if (!h.id) { var s = slug(h.textContent), n = s, k = 2; while (used[n] || document.getElementById(n)) n = s + '-' + k++; h.id = n; }
      used[h.id] = 1;
      return { id: h.id, text: h.textContent.replace(/^\d+\.\s*/, '').trim(), el: h };
    });
    var list = function () { return items.map(function (it) { return '<li><a href="#' + it.id + '">' + it.text.replace(/</g, '&lt;') + '</a></li>'; }).join(''); };
    aside.querySelector('ol').innerHTML = list();
    details.querySelector('ol').innerHTML = list();
    aside.hidden = false; details.hidden = false; doc.classList.add('has-toc');
    // the phone's disclosure closes once a heading is chosen
    details.addEventListener('click', function (e) { if (e.target.closest('a')) details.open = false; });
    // the desktop list marks the section being read: the last heading above the top fifth of the screen
    var links = aside.querySelectorAll('a');
    var mark = function () {
      var line = innerHeight * 0.2, cur = 0;
      for (var i = 0; i < items.length; i++) if (items[i].el.getBoundingClientRect().top <= line) cur = i;
      for (var j = 0; j < links.length; j++) links[j].setAttribute('aria-current', String(j === cur));
    };
    var queued = false;
    addEventListener('scroll', function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; mark(); }); }, { passive: true });
    mark();
  }
})();
